export const massiveImportSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    minHeight: 40,
    height: 40,
    borderColor: state.isFocused ? '#90caf9' : '#d1d5db',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#90caf9' : '#9ca3af'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    minHeight: 40,
    height: 40,
    padding: '0 12px'
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    minHeight: 40,
    height: 40
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    color: '#1f2937',
    display: 'flex',
    alignItems: 'center'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#111827',
    marginLeft: 0,
    marginRight: 0
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#78909C',
    fontSize: '14px',
    marginLeft: 0,
    marginRight: 0
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#111827',
    backgroundColor: state.isFocused ? '#eff6ff' : '#fff'
  })
}
